import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { AnalyticsService } from '@vues/v-common/src/analytics';
import { GoogleTagService } from '@/services/GoogleTagService';
import { createHead } from '@vueuse/head';
import "normalize.css";

const app = createApp(App);

app.use(router);
app.use(createHead());

// Audience of the website (visits, devices, loading time) : see administration > containers > v-enterprise-website
AnalyticsService.start(router, {
    app: 'website',
    backUrl: process.env.VUE_APP_BACK_URL,
    enabled: process.env.NODE_ENV === 'production' && process.env.VUE_APP_ANALYTICS !== 'off'
});
GoogleTagService.start();

app.mount('#app');
